import React, { useEffect } from "react";
import { Modal, Box } from "@mui/material";
import ReservationForm from "./ReservationForm";
import { IoIosCloseCircle } from "react-icons/io";

interface ModalComponentProps {
  modalOpen: boolean; // Prop to handle modal open state
  closeModal: () => void; // Callback function to close the modal
}

const ModalComponent: React.FC<ModalComponentProps> = ({
  modalOpen,
  closeModal,
}) => {
  useEffect(() => {
    if (modalOpen) {
      document.body.style.overflow = "hidden"; // Disable scrolling on body
    } else {
      document.body.style.overflow = "auto"; // Re-enable scrolling on body
    }

    // Cleanup function to reset on component unmount or when modalOpen changes
    return () => {
      document.body.style.overflow = "auto"; // Ensure scrolling is re-enabled
    };
  }, [modalOpen]);

  return (
    <>
      <Modal
        open={modalOpen}
        onClose={closeModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box className="flex justify-center absolute text-custom-atrament top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 md:w-[32rem] xs:w-[30rem] w-full h-auto bg-custom-gray rounded-lg shadow-lg p-6">
          <ReservationForm />
          <button
            onClick={closeModal}
            className="absolute top-4 right-4 text-custom-white bg-custom-red rounded-full p-2"
          >
            <IoIosCloseCircle className="text-4xl text-custom-white" />
          </button>
        </Box>
      </Modal>
    </>
  );
};

export default ModalComponent;
